import { DOOR_TYPE } from './door-type.js';

const DOOR_TYPE_LIST = Object.values(DOOR_TYPE);

export { DOOR_TYPE_LIST };
//# sourceMappingURL=door-type-list.js.map
